const HTTP_SCHEME = 'https';
const INTERNAL_DOMAIN_URL = 'api/emamo';
// eslint-disable-next-line no-unused-vars
const API_URL = `${HTTP_SCHEME}://emamo-api-dev.aiscloud.linkjapan.co.jp/${INTERNAL_DOMAIN_URL}/`;
// eslint-disable-next-line no-unused-vars
const LOCAL_URL = `${HTTP_SCHEME}://emamo-api-dev.aiscloud.linkjapan.co.jp/${INTERNAL_DOMAIN_URL}/`;
const URL_SCHEME = {
  httpScheme: HTTP_SCHEME,
  domainUrl: INTERNAL_DOMAIN_URL,
  host: API_URL,
};

export default URL_SCHEME;
